import { Typography } from "@gti-controls-v2/web-core";
import React from "react";
import homePageStyles from "../../common/styles/HomePage";

const Title = (props) => {
  const styles = homePageStyles;
  return (
    <Typography
      variant={props.variant || "h5"}
      sx={{ ...styles.pageTitle, ...props.sx }}
    >
      {props.children || "\u00A0"}
    </Typography>
  );
};
export default Title;
